import React from "react";
import I18nServicePage from "@/components/I18nServicePage";
import { IMG } from "@/lib/config";

export default function Seminaires() {
  return <I18nServicePage i18nKey="seminaires" image={IMG.seminar} testIdPrefix="seminaires" accentClass="text-accent-orange" />;
}
